import { isCoworkingSelector } from '../../../../../selectors/offerData/offer/isCoworkingSelector';
import { IState } from '../../../../../store';
import { coworkingRentTermsMapper } from './coworkingRentTermsMapper';
import { mapRentTerms } from './mapRentTerms';
import { mapSaleTerms } from './mapSaleTerms';

export function mapTerms(state: IState): [string, string | string[]][] {
  const {
    offerData: { offer },
  } = state;

  if (isCoworkingSelector(state)) {
    return coworkingRentTermsMapper(offer);
  }

  const isRent = offer.dealType === 'rent';

  const termsMapper = isRent ? mapRentTerms : mapSaleTerms;

  return termsMapper(state);
}
